import {mergeDeepRight} from 'ramda'

import {history} from 'utils/history'
import buildUrl from './buildUrl'

import {urlParams} from 'utils/urlParams'

type UpdateHistoryLocationPropsType = {
  url: string
  search?: Record<string, unknown>
  replaceSearchParams?: boolean
  replace?: boolean
}

const updateHistoryLocation = ({
  url,
  search = {},
  replaceSearchParams = false,
  replace = false
}: UpdateHistoryLocationPropsType = {}) => {
  const objectToStringify = replaceSearchParams
    ? search
    : mergeDeepRight(urlParams(), search)

  const newUrl = buildUrl(url, objectToStringify)

  if (replace) {
    history.replace(newUrl)
  } else {
    history.push(newUrl)
  }

  return newUrl
}

export default updateHistoryLocation
